// Production
export const ApiUrl = "https://api.zhushan.org/api";
export const AssetUrl = "https://api.zhushan.org";
export const ToyyibpayUrl = "https://toyyibpay.com"

// Development
// export const ApiUrl = "https://localhost:7150/api";
// export const AssetUrl = "https://localhost:7150";
// export const ToyyibpayUrl = "https://dev.toyyibpay.com"


export const AdminApiEndpoints = {
  //auth 
  login: '/auth/login',
  validateToken: '/auth/validatetoken',

  //bank
  getBank: '/bank',
  getBankList: '/bank/getallactivebank',
  createBank: '/bank/create',
  updateBank: '/bank/update',
  updateBankStatus: '/bank/updatestatus',
  deleteBank: '/bank/delete',

  //banner
  getBanner: '/banner',
  createBanner: '/banner/create',
  updateBanner: '/banner/update',
  updateBannerStatus: '/banner/updatestatus',
  deleteBanner: '/banner/delete',

  //fund
  getFund: '/fund',
  getFundForPayment: '/fund/getallactivefundforpayment',
  createFund: '/fund/create',
  updateFund: '/fund/update',
  updateFundStatus: '/fund/updatestatus',
  deleteFund: '/fund/delete',
  getFundTypeList: '/fund/getfundtype',

  //question
  getQuestion: '/question',
  createQuestion: '/question/create',
  updateQuestion: '/question/update',
  updateQuestionStatus: '/question/updatestatus',
  deleteQuestion: '/question/deletequestion',
  getQuestionList: '/question/getallactivequestion',
  getQuestionTypeList: '/question/getquestiontypes',

  //form
  getForm: '/form',
  createForm: '/form/create',
  updateForm: '/form/update',
  updateFormStatus: '/form/updatestatus',
  deleteForm: '/form/deleteform',
  cloneForm: '/form/cloneform',
  voidForm: '/form/voidform',
  getFormList: '/form/getallavailableform',

  //post
  getPost: '/post',
  createPost: '/post/create',
  updatePost: '/post/update',
  updatePostStatus: '/post/updatestatus',
  deletePost: '/post/delete',
  getPostCategoryList: '/post/getpostcategory',
  getPostStatusList: '/post/getpoststatus',
  voidPost: '/post/void',

  //inquiry
  getInquiry: '/inquiry',
  createInquiry: '/inquiry/create',
  updateInquiry: '/inquiry/update',
  updateInquiryStatus: '/inquiry/updatestatus',
  getInquiryStatusList: '/inquiry/getinquirystatus',

  //about us 1
  getAboutUsSection1: '/aboutussection1',
  createAboutUsSection1: '/aboutussection1/create',
  updateAboutUsSection1: '/aboutussection1/update',

  //about us 2
  getAboutUsSection2: '/aboutussection2',
  createAboutUsSection2: '/aboutussection2/create',
  updateAboutUsSection2: '/aboutussection2/update',

  //about us 3
  getAboutUsSection3: '/aboutussection3',
  createAboutUsSection3: '/aboutussection3/create',
  updateAboutUsSection3: '/aboutussection3/update',

  //about us 4
  getAboutUsSection4: '/aboutussection4',
  createAboutUsSection4: '/aboutussection4/create',
  updateAboutUsSection4: '/aboutussection4/update',

  //role
  getRole: '/role',
  createRole: '/role/create',
  updateRole: '/role/update',
  updateRoleStatus: '/role/updaterolestatus',
  deleteRole: '/role/delete',

  //module
  getModule: '/module',

  //user
  getUserList: '/user/getallactiveuser',
  getUser: '/user',
  createUser: '/user/create',
  updateUser: '/user/update',
  updateUserStatus: '/user/updatestatus',
  deleteUser: '/user/delete',

  //broadcast
  getBroadcast: '/broadcast',
  createBroadcast: '/broadcast/create',
  updateBroadcast: '/broadcast/update',
  updateBroadcastStatus: '/broadcast/updatestatus',
  deleteBroadcast: '/broadcast/delete',
  getBroadcastTypeList: '/broadcast/getBroadcastType',
  getBroadcastStatusList: '/broadcast/getBroadcastStatus',

  //subscriber
  getSubscriber: '/subscriber',
  createSubscriber: '/subscriber/create',
  updateSubscriber: '/subscriber/updatesubscriber',
  updateSubscriberStatus: '/subscriber/updatesubscriberstatus',
  deleteSubscriber: '/subscriber/delete',

  //application
  getApplication: '/application',
  kivApplication: '/application/kiv',
  rejectApplication: '/application/reject',
  resetApplication: '/application/reset',
  approveApplication: '/application/approve',
  getApplicationStatusList: '/application/getapplicationstatus',

  //activity payment
  getActivityPayment: '/activitypayment',
  getActivityPaymentMethod: '/activitypayment/getpaymentmethod',
  getActivityPaymentStatusList: '/activitypayment/getactivitypaymentstatus',
  validateAcceptanceNo: '/applicationacceptancenumber/validateacceptancenumber',
  createActivityPayment: '/activitypayment/create',
  verifyActivityPayment: '/activitypayment/verify',
  voidActivityPayment: '/activitypayment/void',
  rejectActivityPayment: '/activitypayment/reject',
  invalidActivityPayment: '/activitypayment/invalid',
  refundedActivityPayment: '/activitypayment/refunded',

  //donation payment
  getDonationPayment: '/donationpayment',
  getDonationPaymentMethod: '/donationpayment/getpaymentmethod',
  getDonationPaymentStatusList: '/donationpayment/getdonationpaymentstatus',
  createDonationPayment: '/donationpayment/create',
  verifyDonationPayment: '/donationpayment/verify',
  voidDonationPayment: '/donationpayment/void',

  //featured donation
  getFeaturedDonation: '/featureDonation',
  createFeaturedDonation: '/featureDonation/create',
  updateFeaturedDonation: '/featureDonation/update',
  updateFearuredDonationStatus: '/featureDonation/updatestatus',
  deleteFeaturedDonation: '/featureDonation/delete',

  //featured donor
  getFeaturedDonor: '/featureDonor',
  getFeaturedDonorStatusList: '/featureDonor/getAllFeatureDonorStatus',
  getFeaturedDonorByGuid: '/featureDonor/getFeatureDonorByGuid',
  updateFeaturedDonorRemark: '/featureDonor/updateFeatureDonorRemark',
  collectFeaturedDonor: '/featureDonor/collectFeatureDonor',
  rejectFeaturedDonor: '/featureDonor/rejectFeatureDonor',
  resetFeaturedDonor: '/featureDonor/resetFeatureDonor',

  //RTE
  uploadImage: '/richtexteditor/imageUploader',
};

export const UserApiEndpoints = {
  
  getBanner: '/banner/getallactivebanner',

  subscribeNewsletter: '/subscriber/create',
  unsubscribeNewsletter: '/subscriber/unsubscribe',

  getAboutUsSection1: '/aboutussection1',
  getAboutUsSection2: '/aboutussection2',
  getAboutUsSection3: '/aboutussection3',
  getAboutUsSection4: '/aboutussection4',

  createInquiry: '/inquiry/create',

  //Activity
  getActivity: '/post/getallactivepost',
  getActivityByGuid: '/post',
  getActivityRegistrationForm: '/post/getpostforregister',
  customerRegistration: '/application/customerregistration', 

  //Payment
  getBank: '/bank/getallactivebank',
  createActivityPayment: '/activitypayment/customermakepayment',
  createActivityPaymentGateway: '/activitypayment/customerpayment/paymentgateway',
  remakeActivityPaymentGateway: '/activitypayment/customerremakepayment/paymentgateway',
  validateAcceptanceNo: '/applicationacceptancenumber/validateacceptancenumber',
  getActivityPaymentMethod: '/activitypayment/getpaymentmethod',
  getApplication: '/application',

  getFund: '/fund/getallactivefundforpayment',
  createDonationPayment: '/donationpayment/customermakepayment',
  createDonationPaymentGateway: '/donationpayment/customermakepayment/paymentgateway',
  getDonationPaymentMethod: '/donationpayment/getpaymentmethod',

  getFundContent: '/fund/getallactivefund',

  //Featured
  getFeaturedDonation: '/featureDonation/getAllActiveFeatureDonation',
  getFeaturedDonationByGuid: '/featureDonation/getActiveFeatureDonationByGuid',
  registerFeaturedDonation: '/featureDonor/registerFeatureDonor',

  //Callback
  activityPaymentCallback: '/billtransactionlog/activitycallbackparameter',
};
